import { Button, Modal } from "react-bootstrap";
import { Tooltip } from "antd";
import { useAppDispatch } from "src/hooks/redux";
import { resolveHelpRequest } from "../../services/HelpRequestService";
import { capitalize, formatPhone } from "../../utils/Utils";
import { useRef } from "react";

const HelpRequestModal = ({ show, onCancel, request, applicant }) => {
  const dispatch = useAppDispatch();
  const emailDiv = useRef(null);
  const resolveRequest = () => {
    dispatch(resolveHelpRequest(applicant, request));
    onCancel();
  };
  if (!request || !applicant) {
    return null;
  }
  const filtered_applicant =
    applicant &&
    applicant.applicants.find((a: any) => a.id === request.applicantId);
  const resolvedApplicant =
    filtered_applicant ??
    (request.applicantFirstName ||
    request.applicantLastName ||
    request.applicantEmail ||
    request.applicantPhone
      ? {
          firstName: request.applicantFirstName,
          lastName: request.applicantLastName,
          emailAddress: request.applicantEmail,
          phoneNumber: request.applicantPhone,
        }
      : null);
  const formatDate = (input: string) => {
    const d = new Date(input);
    const rawHours = d.getHours();
    const hours = rawHours % 12 || 12;
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const ampm = rawHours >= 12 ? "pm" : "am";
    return `${hours}:${minutes}${ampm}, ${d.toLocaleDateString()}`;
  };

  const hasEllipsis = () => {
    if (emailDiv.current !== null) {
      return emailDiv.current["offsetWidth"] < emailDiv.current["scrollWidth"];
    }
    return true;
  };

  return (
    <Modal centered show={show}>
      <Modal.Header className="border-bottom">
        <Modal.Title>{applicant.unitId} - Help Request</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="details block-labels">
          <div className="row">
            <div className="col-6">
              <label className="d-block">Topic</label>
              {request.helpRequestTopic}
            </div>
            <div className="col-6">
              <label className="d-block">Applicant Name</label>
              {resolvedApplicant &&
                (resolvedApplicant.firstName || resolvedApplicant.lastName) &&
                capitalize(
                  `${resolvedApplicant.firstName ?? ""} ${
                    resolvedApplicant.lastName ?? ""
                  }`.trim()
                )}
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <label className="d-block">Date Sent</label>
              {(request.modifiedDate && formatDate(request.modifiedDate)) ||
                (request.createdDate && formatDate(request.createdDate))}
            </div>
            <div className="col-6 text-truncate" ref={emailDiv}>
              <label className="d-block">Email</label>
              <span>
                {hasEllipsis() ? (
                  <Tooltip
                    placement="top"
                    title={resolvedApplicant && resolvedApplicant.emailAddress}
                    color={"#2a3244"}
                    mouseEnterDelay={0}
                    overlayClassName="help-request-email-tooltip"
                  >
                    {resolvedApplicant && resolvedApplicant.emailAddress}
                  </Tooltip>
                ) : (
                  resolvedApplicant && resolvedApplicant.emailAddress
                )}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-6"></div>
            <div className="col-6 not-truncated">
              <label className="d-block">Phone</label>
              {resolvedApplicant && formatPhone(resolvedApplicant.phoneNumber)}
            </div>
          </div>
          <div className="row additional-comments">
            <div className="col">
              <label className="d-block">Additional Comments</label>
              {request.additionalComments}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top">
        <Button className="cancel-btn" onClick={onCancel}>
          Close
        </Button>
        <Button variant="primary" onClick={resolveRequest}>
          Resolve
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HelpRequestModal;
